// Module
var code = `<div class="onboarding-main">
    <div class='slide{{#if .small}} small{{/if}}'>
        <terceraButton 
            terceraButtonStyle="button-onboarding-close"
            on-btnClick="closeClick"
            SVG="true"
            name="closeCrossBtn"/>

        <div class="img_slide_1 active-slide" id="slide_number_1">
            <div class="slide1_headerText1">{{.slide1_header1}}</div>
            <div class="slide1_bodyText1">{{.slide1_text1}}</div>
        </div>

        <div class="img_slide_2" id="slide_number_2">
            <div class="slide2_headerText1">{{.slide2_header1}}</div>
            <div class="slide2_bodyText1">{{{.slide2_text1}}}</div>
            <div class="slide2_headerText2">{{.slide2_header2}}</div>
            <div class="slide2_bodyText2">{{.slide2_text2}}</div>
            <div class="slide2_headerText3">{{.slide2_header3}}</div>
            <div class="slide2_bodyText3">{{.slide2_text3}}</div>
        </div>

        <div class="img_slide_3" id="slide_number_3">
            <div class="slide3_headerText1">{{.slide3_header1}}</div>
            <div class="slide3_bodyText1">{{.slide3_text1}}</div>
        </div>


        <div class="img_slide_4" id="slide_number_4">
            <div class="slide4_headerText1">{{.slide4_header1}}</div>
            <div class="slide4_bodyText1">{{.slide4_text1}}</div>
            <div class="slide4_bodyText2">{{.slide4_text2}}</div>
            <div class="slide4_bodyText3">{{.slide4_text3}}</div>
        </div>

        <div class="img_slide_5" id="slide_number_5">
            <div class="slide5_headerText1">{{.slide5_header1}}</div>
            <div class="slide5_bodyText1">{{.slide5_text1}}</div>
            <div class="slide5_bodyText2">{{.slide5_text2}}</div>
        </div>

        <div class="img_slide_6" id="slide_number_6">
            <div class="slide6_headerText1">{{.slide6_header1}}</div>
            <div class="slide6_bodyText1">{{.slide6_text1}}</div>
            <div class="slide6_headerText2">{{.slide6_header2}}</div>
            <div class="slide6_bodyText2">{{.slide6_text2}}</div>
        </div>

        <div class="img_slide_7" id="slide_number_7">
            <div class="slide7_headerText1">{{.slide7_header1}}</div>
            <div class="slide7_bodyText1">{{.slide7_text1}}</div>
            <div class="slide7_headerText2">{{.slide7_header2}}</div>
            <div class="slide7_bodyText2">{{.slide7_text2}}</div>
            <div class="slide7_headerText3">{{.slide7_header3}}</div>
            <div class="slide7_bodyText3">{{.slide7_text3}}</div>
        </div>

        <div class="img_slide_8" id="slide_number_8">
            <div class="slide8_headerText1">{{.slide8_header1}}</div>
            <div class="slide8_bodyText1">{{.slide8_text1}}</div>
            <div class="slide8_headerText2">{{.slide8_header2}}</div>
            <div class="slide8_bodyText2">{{.slide8_text2}}</div>
        </div>
    </div>
    <div class="onboarding-footer">
        <div class="buttons-bar">
            <terceraButton 
                terceraButtonStyle="js-button-onboarding-back{{#if showButton === 1}} visibility-hidden{{/if}}"
                text="{{.backButtonText}}"
                on-btnClick="backClick"
                SVG="true"
                name="ArrowLeft"/>
            <div class="numberBlock">{{.counterText}}</div>
            {{#if .showButton !== 8}}
                <terceraButton 
                    terceraButtonStyle="js-button-onboarding-next"
                    text="{{.nextButtonText}}"
                    on-btnClick="nextClick"
                    SVG="true"
                    name="ArrowRight"/>
            {{else}}
                <terceraButton 
                    terceraButtonStyle="js-button-onboarding-done"
                    text="{{.doneButtonText}}"
                    on-btnClick="doneClick"
                    SVG="true"
                    name="checkBox"/>
            {{/if}}
        </div>
        <div class="inputs-bar">
            <input type="radio" name="slider" id="slider_1" checked="checked" on-click="@this.inputClick(1)">
            <label for="slider_1"></label>

            <input type="radio" name="slider" id="slider_2" on-click="@this.inputClick(2)">
            <label for="slider_2"></label>

            <input type="radio" name="slider" id="slider_3" on-click="@this.inputClick(3)">
            <label for="slider_3"></label>

            <input type="radio" name="slider" id="slider_4" on-click="@this.inputClick(4)">
            <label for="slider_4"></label>

            <input type="radio" name="slider" id="slider_5" on-click="@this.inputClick(5)">
            <label for="slider_5"></label>

            <input type="radio" name="slider" id="slider_6" on-click="@this.inputClick(6)">
            <label for="slider_6"></label>

            <input type="radio" name="slider" id="slider_7" on-click="@this.inputClick(7)">
            <label for="slider_7"></label>

            <input type="radio" name="slider" id="slider_8" on-click="@this.inputClick(8)">
            <label for="slider_8"></label>
        </div>
    </div>
</div>`;
// Exports
export default code;